import { render, staticRenderFns } from "./chats.vue?vue&type=template&id=05052736&lang=pug"
import script from "./chats.vue?vue&type=script&lang=js"
export * from "./chats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports